import { EscalationProfileEndpoints } from '@/modules/seller-management/escalation-profile/api/escalationProfileEndpoints'

/**
 * Escalation Profile endpoint instance
 * instantiate Escalation Profile api class with different api path
 */
export const escalationProfileEndpoints = new EscalationProfileEndpoints()
